import { defineMessages } from 'react-intl';
const i18nKey = 'DevelopersTab';
const messages = defineMessages({
  developersTitle: {
    id: `${i18nKey}.developersTitle`,
    defaultMessage: 'Build with OnchainKit',
    description: `
    #Component: TextHeadline
    #CharLimit: 55
    #Context: Developers title`
  },
  developersDescription: {
    id: `${i18nKey}.developersDescription`,
    defaultMessage: 'Making building onchain easy for everyone.',
    description: `
    #Component: TextLabel2
    #CharLimit: 70
    #Context: Developers tab description`
  },
  developersLinkText: {
    id: `${i18nKey}.developersLinkText`,
    defaultMessage: 'Go to OnchainKit',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Go to OnchainKit button`
  },
  mobileNavBarLinkText: {
    id: `${i18nKey}.mobileNavBarLinkText`,
    defaultMessage: 'See all',
    description: `
    #Component: Button
    #CharLimit: 50
    #Context: Navbar link text for mobile`
  },
  rosetta: {
    id: `${i18nKey}.rosetta`,
    defaultMessage: 'Rosetta',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Rosetta page label (CharLimit autocalculated to 40)`
  },
  rosettaDescription: {
    id: `${i18nKey}.rosettaDescription`,
    defaultMessage: 'Integrate your blockchain everywhere',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Rosetta page label (CharLimit autocalculated to 80)`
  },
  walletLink: {
    id: `${i18nKey}.walletLink`,
    defaultMessage: 'Wallet SDK',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Wallet page label (CharLimit autocalculated to 45)`
  },
  walletLinkDescription: {
    id: `${i18nKey}.walletLinkDescription`,
    defaultMessage: 'Link onchain apps to Coinbase Wallet',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: WalletLink page label (CharLimit autocalculated to 80)`
  },
  bisonTrails: {
    id: `${i18nKey}.bisonTrails`,
    defaultMessage: 'Bison Trails',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Bison Trails page label (CharLimit autocalculated to 45)`
  },
  bisonTrailsDescription: {
    id: `${i18nKey}.bisonTrailsDescription`,
    defaultMessage: 'Pioneering blockchain infrastructure',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Bison Trails page label (CharLimit autocalculated to 80)`
  },
  developerHub: {
    id: `${i18nKey}.developerHub`,
    defaultMessage: 'Developer Hub',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Developer Hub page label (CharLimit autocalculated to 45)`
  },
  developerHubDescription: {
    id: `${i18nKey}.developerHubDescription`,
    defaultMessage: 'Explore our developer documentation',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Connect to Coinbase wallets (CharLimit autocalculated to 75)`
  },
  connectDescription: {
    id: `${i18nKey}.connectDescription`,
    defaultMessage: 'Offer Coinbase users login to onchain apps',
    description: `
    #Component: Link
    #CharLimit: 85
    #Context: Connect page description (CharLimit autocalculated to 85)`
  },
  connectLinkTitle: {
    id: `${i18nKey}.connectLinkTitle`,
    defaultMessage: 'Connect - Enable users to buy, sell and store crypto',
    description: `
    #Component: Link
    #CharLimit: 100
    #Context: Connect link title (CharLimit autocalculated to 100)`
  },
  connectIconAltText: {
    id: `${i18nKey}.connectIconAltText`,
    defaultMessage: 'Connect - Enable users to buy, sell and store crypto',
    description: `
    #Component: Link
    #CharLimit: 100
    #Context: Connect icon alt text (CharLimit autocalculated to 100)`
  },
  commerce: {
    id: `${i18nKey}.commerce`,
    defaultMessage: 'Commerce API',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Coinbase Commerce page label (CharLimit autocalculated to 45)`
  },
  commerceDescription: {
    id: `${i18nKey}.commerceDescription`,
    defaultMessage: 'Accept crypto payments from customers',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Coinbase Commerce page description (CharLimit autocalculated to 80)`
  },
  commerceLinkTitle: {
    id: `${i18nKey}.commerceLinkTitle`,
    defaultMessage: 'Commerce - Enable users to buy, sell and store crypto',
    description: `
    #Component: Link
    #CharLimit: 100
    #Context: Connect link title (CharLimit autocalculated to 100)`
  },
  base: {
    id: `${i18nKey}.base`,
    defaultMessage: 'Base',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: Coinbase Base page label (CharLimit autocalculated to 35)`
  },
  baseDescription: {
    id: `${i18nKey}.baseDescription`,
    defaultMessage: 'An Ethereum L2 to build onchain apps',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Coinbase Base page description (CharLimit autocalculated to 80)`
  },
  baseLinkTitle: {
    id: `${i18nKey}.baseLinkTitle`,
    defaultMessage: 'Base - An Ethereum L2 to build onchain apps',
    description: `
    #Component: Link
    #CharLimit: 85
    #Context: Coinbase Base link title (CharLimit autocalculated to 85)`
  },
  baseIconAltText: {
    id: `${i18nKey}.baseIconAltText`,
    defaultMessage: 'Base - An Ethereum L2 to build onchain apps',
    description: `
    #Component: Link
    #CharLimit: 85
    #Context: Coinbase Base alt text (CharLimit autocalculated to 85)`
  },
  coinbasePaySdk: {
    id: `${i18nKey}.coinbasePaySdk`,
    defaultMessage: 'Onramp',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Coinbase Pay SDK alt text (CharLimit autocalculated to 40)`
  },
  coinbasePaySdkDescription: {
    id: `${i18nKey}.coinbasePaySdkDescription`,
    defaultMessage: 'A secure fiat-to-crypto solution',
    description: `
    #Component: Link
    #CharLimit: 70
    #Context: Coinbase Pay SDK description (CharLimit autocalculated to 70)`
  },
  coinbasePaySdkLinkTitle: {
    id: `${i18nKey}.coinbasePaySdkLinkTitle`,
    defaultMessage: 'Onramp - A secure fiat–to–crypto solution',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Coinbase Pay SDK - link title (CharLimit autocalculated to 80)`
  },
  coinbasePaySdkIconAltText: {
    id: `${i18nKey}.coinbasePaySdkIconAltText`,
    defaultMessage: 'Easy, secure fiat-to-crypto solution',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Coinbase Pay SDK - icon alt text (CharLimit autocalculated to 80)`
  },
  // Link titles
  developerHubLinkTitle: {
    id: `${i18nKey}.developerHubLinkTitle`,
    defaultMessage: 'Developer Hub - Explore our developer documentation',
    description: `
    #Component: Link
    #CharLimit: 100
    #Context: Developer Hub link title (CharLimit autocalculated to 100)`
  },
  rosettaLinkTitle: {
    id: `${i18nKey}.rosettaLinkTitle`,
    defaultMessage: 'Rosetta - Integrate your blockchain everywhere',
    description: `
    #Component: Link
    #CharLimit: 90
    #Context: Rosetta link title (CharLimit autocalculated to 90)`
  },
  walletLinkLinkTitle: {
    id: `${i18nKey}.walletLinkLinkTitle`,
    defaultMessage: 'Link onchain apps to Coinbase Wallet',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: WalletLink link title (CharLimit autocalculated to 80)`
  },
  bisonTrailsLinkTitle: {
    id: `${i18nKey}.bisonTrailsLinkTitle`,
    defaultMessage: 'Bison Trails - Run infrastructure on multiple blockchains',
    description: `
    #Component: Link
    #CharLimit: 105
    #Context: Bison Trails link title (CharLimit autocalculated to 105)`
  },
  cloud: {
    id: `${i18nKey}.cloud`,
    defaultMessage: 'Cloud',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: cloud link title (CharLimit autocalculated to 35)`
  },
  cloudLinkTitle: {
    id: `${i18nKey}.cloudLinkTitle`,
    defaultMessage: 'Cloud',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: cloud link title (CharLimit autocalculated to 35)`
  },
  cloudDescription: {
    id: `${i18nKey}.cloudDescription`,
    defaultMessage: 'Developer tools and APIs',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: cloud link description (CharLimit autocalculated to 60)`
  },
  cloudIconAltText: {
    id: `${i18nKey}.cloudIconAltText`,
    defaultMessage: 'cloud icon',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: cloud icon alt text (CharLimit autocalculated to 45)`
  },
  developerPlatform: {
    id: `${i18nKey}.developerPlatform`,
    defaultMessage: 'Developer Platform',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Developer Platform title (CharLimit autocalculated to 55)`
  },
  developerPlatformLinkTitle: {
    id: `${i18nKey}.developerPlatformLinkTitle`,
    defaultMessage: 'Developer tools and APIs',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: developer platform link title (CharLimit autocalculated to 55)`
  },
  developerPlatformDescription: {
    id: `${i18nKey}.developerPlatformDescription`,
    defaultMessage: 'Developer tools and APIs',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: developer platform link description (CharLimit autocalculated to 60)`
  },
  developerPlatformIconAltText: {
    id: `${i18nKey}.developerPlatformIconAltText`,
    defaultMessage: 'developer platform icon',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: developer platform  icon alt text (CharLimit autocalculated to 60)`
  },
  walletIconAltText: {
    id: `${i18nKey}.walletIconAltText`,
    defaultMessage: 'wallet icon',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: wallet icon alt text (CharLimit autocalculated to 45)`
  },
  waas: {
    id: `${i18nKey}.waas`,
    defaultMessage: 'Wallets',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: waas link title (CharLimit autocalculated to 40)`
  },
  waasLinkTitle: {
    id: `${i18nKey}.waasLinkTitle`,
    defaultMessage: 'Wallets - Enable the best wallet experience for any user',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: waas link title (CharLimit autocalculated to 40)`
  },
  waasIconAltText: {
    id: `${i18nKey}.waasIconAltText`,
    defaultMessage: 'Wallets icon',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: waas icon alt text (CharLimit autocalculated to 45)`
  },
  waasDescription: {
    id: `${i18nKey}.waasDescription`,
    defaultMessage: 'Enable the best wallet experience for any user',
    description: `
    #Component: Link
    #CharLimit: 90
    #Context: waas link description (CharLimit autocalculated to 90)`
  },
  onchainKit: {
    id: `${i18nKey}.onchainKit`,
    defaultMessage: 'OnchainKit',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: OnchainKit link title`
  },
  onchainKitLinkTitle: {
    id: `${i18nKey}.onchainKitLinkTitle`,
    defaultMessage: 'OnchainKit - Components for building onchain apps',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: waas link title (CharLimit autocalculated to 40)`
  },
  onchainKitIconAltText: {
    id: `${i18nKey}.onchainKitIconAltText`,
    defaultMessage: 'OnchainKit icon',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: onchainKit icon alt text`
  },
  onchainKitDescription: {
    id: `${i18nKey}.onchainKitDescription`,
    defaultMessage: 'Components for building onchain apps',
    description: `
    #Component: Link
    #CharLimit: 90
    #Context: OnchainKit link description`
  },
  commerceIconAltText: {
    id: `${i18nKey}.commerceIconAltText`,
    defaultMessage: 'commerce icon',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Commerce icon alt text (CharLimit autocalculated to 45)`
  },
  delegate: {
    id: `${i18nKey}.delegate`,
    defaultMessage: 'Staking',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Query & Transact link title (CharLimit autocalculated to 40)`
  },
  delegateIconAltText: {
    id: `${i18nKey}.delegateIconAltText`,
    defaultMessage: 'delegate icon - Stake tokens to earn rewards',
    description: `
    #Component: Link
    #CharLimit: 90
    #Context: Commerce icon alt text (CharLimit autocalculated to 90)`
  },
  delegateLinkTitle: {
    id: `${i18nKey}.delegateTitle`,
    defaultMessage: 'Staking validators and tooling',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: delegate title text (CharLimit autocalculated to 40)`
  },
  delegateDescription: {
    id: `${i18nKey}.delegateDescription`,
    defaultMessage: 'Staking validators and tooling',
    description: `
    #Component: Link
    #CharLimit: 70
    #Context: delegate description text (CharLimit autocalculated to 70)`
  }
});
export { messages as default };
//# sourceMappingURL=messages.js.map
